export const setupCopyDa = {
    yourHospitalNumber: "Dit hospitalsnummer",
    hospitalNumberIntro:
        "Dit hospitalsnummer hjælper med at identificere dig i hospitalsystemet. Hvis din behandler har tildelt dig et nummer, skal du angive det her.",
    hospitalNumberFieldHint: "Det hjælper med at identificere dig i hospitalsystemet.",
    dontKnow: "Jeg ved det ikke",
    skipForNow: "Jeg ved det ikke endnu",
    whichSideAffectedTitle: "Hvilken side af kroppen er berørt?",
    sideSetupLeadInTrackersOnly:
        "Vi skal vide, hvilken side af kroppen der er berørt, så vi kan stille dig de rigtige spørgsmål til følgende spørgeskemaer: ",
    sideSetupLeadInProceduresOnly: "Vi skal vide, hvilken side af kroppen der er berørt, så vi kan matche det med: ",
    sideSetupLeadInBoth:
        "Vi skal vide, hvilken side af kroppen der er berørt, så vi kan stille dig de rigtige spørgsmål til følgende spørgeskemaer og din behandling: ",
    sideSetupBothSidesNote:
        "Hvis begge sider er berørt, skal du vælge Begge. Så tilføjer vi et spørgeskema for hver side.",
    saveDate: "Gem dato",
    pickDate: "Vælg en dato",
    clearDateAndTime: "Ryd dato og tidspunkt",
    missingReferenceDateDataError:
        "Kunne ikke gemme proceduredato - manglende dataidentifikatorer. Prøv at opdatere siden, eller kontakt support, hvis problemet fortsætter.",
    referenceDateMinMessage: "Vælg en dato, der ikke ligger mere end 2 år tilbage.",
    referenceDateMaxMessage: "Vælg en dato, der ikke ligger mere end 2 år frem.",
    referenceDateQuestion: (kind: string) => {
        if (kind === "product") return "Hvilken dato brugte eller vil du bruge produktet?";
        if (kind === "injection") return "Hvilken dato havde eller vil du have injektionen?";
        if (kind === "surgery") return "Hvilken dato havde eller vil du have operationen?";
        if (kind === "medication") return "Hvilken dato begyndte eller vil du begynde medicinen?";
        if (kind === "shockwave") return "Hvilken dato begyndte eller vil du begynde stødbølgebehandlingen?";
        if (kind === "consultation") return "Hvilken dato havde eller vil du have konsultationen?";
        return "Hvilken dato havde eller vil du have behandlingen?";
    },
    referenceDateDescriptionFor: (phrase: string, kind: string) => {
        if (kind === "product") {
            return `Vælg hvornår du begyndte at bruge ${phrase} - tidligere eller kommende - så dine opfølgningsspørgsmål matcher det.`;
        }
        if (kind === "injection") {
            return `Vælg datoen for din injektion - tidligere eller kommende - så dine opfølgningsspørgsmål matcher den.`;
        }
        if (kind === "shockwave") {
            return `Vælg datoen for din stødbølgebehandling - tidligere eller kommende - så dine opfølgningsspørgsmål matcher den.`;
        }
        if (kind === "surgery") {
            return `Vælg datoen for din ${phrase} - tidligere eller kommende - så dine opfølgningsspørgsmål matcher den.`;
        }
        if (kind === "consultation") {
            return `Vælg datoen for din konsultation - tidligere eller kommende - så dine opfølgningsspørgsmål matcher den.`;
        }
        return `Vælg datoen for din ${phrase} - tidligere eller kommende - så dine opfølgningsspørgsmål matcher den.`;
    },
    productStartDateLabel: (phrase: string) => `Datoen du begyndte ${phrase}`,
    chooseDateError: (phrase: string) => `Vælg venligst datoen for din ${phrase}`,
    chooseProductStartDateError: (phrase: string) => `Vælg venligst hvornår du begyndte at bruge ${phrase}`,
    savedProcedureDateToast: (phrase: string) => `Din ${phrase}-dato er gemt.`,
    savedProductStartDateToast: (phrase: string) => `Din startdato for ${phrase} er gemt.`,
};
